var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectronicSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 28.3328L31.4067 25.2195C31.2879 25.1069 31.1386 25.0317 30.9774 25.0034C30.8162 24.9751 30.6502 24.9949 30.5002 25.0603C30.3502 25.1258 30.2228 25.2339 30.1338 25.3713C30.0448 25.5086 29.9983 25.6692 30 25.8328V26.6662C30 27.1082 29.8244 27.5321 29.5118 27.8447C29.1993 28.1572 28.7754 28.3328 28.3333 28.3328H25C24.558 28.3328 24.134 28.1572 23.8215 27.8447C23.5089 27.5321 23.3333 27.1082 23.3333 26.6662C23.3333 22.4245 16.6817 20.0495 9.16667 19.9995C8.0616 19.9995 7.00179 20.4385 6.22039 21.2199C5.43899 22.0013 5 23.0611 5 24.1662C5 25.2712 5.43899 26.331 6.22039 27.1124C7.00179 27.8938 8.0616 28.3328 9.16667 28.3328C16.0883 28.3328 17.075 9.50783 18.68 5.83283C18.9511 5.21249 19.3693 4.66755 19.8984 4.24518C20.4275 3.82281 21.0516 3.53572 21.7166 3.40876C22.3815 3.2818 23.0675 3.31879 23.7149 3.51653C24.3624 3.71427 24.952 4.06681 25.4326 4.54363C25.9132 5.02046 26.2703 5.60721 26.4732 6.25311C26.676 6.89901 26.7184 7.58462 26.5967 8.25059C26.475 8.91657 26.1928 9.54285 25.7747 10.0753C25.3565 10.6077 24.8149 11.0302 24.1967 11.3062",
    stroke: "url(#paint0_linear_623_3462)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 34.9998H35",
    stroke: "url(#paint1_linear_623_3462)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_3462",
    x1: 5,
    y1: 15.8338,
    x2: 35,
    y2: 15.8338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_3462",
    x1: 5,
    y1: 35.4998,
    x2: 35,
    y2: 35.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicSignature);
export default __webpack_public_path__ + "static/media/electronic_signature.7dda9f758a9696ee94d5f670a1f6d816.svg";
export { ForwardRef as ReactComponent };